module.exports = __webpack_public_path__ + "static/media/IMG_3473_sm.57b97d9a.jpg";